<template>
  <Card class="page-package">
    <div style="text-align: right; margin-bottom: 15px">
      <el-button
        type="primary"
        round
        @click="showModal({
        service_id: '',
        title: '',
        price: 100,
        intro: '',
        image: ''
      })"
      >新增服务包</el-button>
    </div>
    <Table
      :columns="columns"
      :data="dataSource"
      :loading="loading"
    >
      <template
        slot-scope="{row}"
        slot="image"
      >
        <el-image
          style="max-width: 80px;max-height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        />
      </template>
      <template
        slot-scope="{row}"
        slot="price"
      >
        {{ row.price ? "¥" + row.price : row.price }}
      </template>
      <template
        slot-scope="{ row }"
        slot="action"
      >
        <!-- <el-button
          type="text"
          style="margin-right: 10px"
          @click="showModal(row)"
        >编辑</el-button> -->
        <el-popconfirm
          title="确定删除该服务包吗？"
          @confirm="deleteTeamPackage(row.id)"
        >
          <el-button
            slot="reference"
            type="text"
            class="error"
          >删除</el-button>
        </el-popconfirm>
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal
      v-model="show"
      :mask-closable="false"
      width="1250"
      @on-cancel="cancel"
    >
      <div
        slot="header"
        style="text-align: center"
      >
        <span>{{ "新增服务包" }}</span>
      </div>
      <el-row
        type="flex"
        justify="start"
        style="margin-bottom: 20px"
      >

        <el-col style="margin-left: 15px;width:300px">
          <el-input
            v-model="goodsName"
            placeholder="请输入商品名称"
            clearable
          />
        </el-col>
        <el-col style="margin-left: 15px;width:300px">
          <el-select
            v-model="goodsCategory"
            placeholder="请选择商品类型"
          >
              <el-option
                v-for="item in categorys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
          </el-select>
        </el-col>
        <el-col style="margin-left: 15px">
          <el-button
            type="primary"
            @click="handleSearch()"
          >筛选</el-button>
        </el-col>
      </el-row>
      <Table
        :columns="serviceColumns"
        :data="serviceSource"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 420, x: 1200 }"
        @on-selection-change="handleSelectionChange"
      >
        <template
          slot-scope="{row}"
          slot="image"
        >
          <el-image
            style="max-width: 80px;max-height: 80px"
            :src="row.image"
            :preview-src-list="[row.image]"
          />
        </template>
        <template
          slot-scope="{row}"
          slot="price"
        >
          {{ row.price ? "¥" + row.price : row.price }}
        </template>
      </Table>
      <div style="margin-top: 16px; text-align: right">
        <Page
          :total="addTotal"
          :current="addPage"
          :page-size="addSize"
          :page-size-opts="addSizes"
          :show-total="true"
          :show-elevator="true"
          :show-sizer="true"
          @on-change="onAddCurrentChange"
          @on-page-size-change="onAddSizeChange"
        />
      </div>
      <div
        slot="footer"
        style="text-align: center"
      >
        <el-button
          type="info"
          round
          @click="cancel"
        >取消</el-button>
        <el-button
          type="primary"
          round
          :loading="modalLoading"
          @click="save"
        >保存</el-button>
      </div>
    </Modal>

  </Card>
</template>
<script>
import { addTeamPackageApi, updateTeamPackageApi, getTeamPackageApi, deleteTeamPackageApi, fetchGoodsList } from '../../api/manage'
export default {
  props: {
    row: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      //添加服务包
      consumeVisible: false,
      serviceSource: [],
      columns: [
        {
          title: 'ID',
          align: 'center',
          key: 'service_id'
        },
        {
          title: '名称',
          align: 'center',
          key: 'title'
        },
        {
          title: '缩略图',
          align: 'center',
          key: 'image',
          slot: 'image'
        },
        {
          title: '价格',
          align: 'center',
          key: 'price',
          slot: 'price'
        },
        // {
        //   title: '简介',
        //   align: 'center',
        //   key: 'intro'
        // },
        {
          title: '操作',
          align: 'center',
          key: 'action',
          slot: 'action'
        }
      ],
      serviceColumns: [
        {
          type: 'selection',
          width: 55,
          align: 'center'
        },
        {
          title: '商品缩略图',
          dataIndex: 'image',
          key: 'image',
          align: 'center',
          slot: 'image'
        },
        {
          title: '商品编码',
          dataIndex: 'service_id',
          key: 'service_id',
          align: 'center'
        },
        {
          title: '商品名称',
          dataIndex: 'title',
          key: 'title',
          align: 'center'
        },
        {
          title: '价格',
          dataIndex: 'price',
          key: 'price',
          align: 'center',
          slot: 'price'
        }
      ],
      // 列表
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      // 弹窗
      addTotal: 0,
      addPage: 1,
      addSize: 10,
      addSizes: [10, 20, 30, 40, 50],
      //
      dataSource: [],
      loading: false,
      modalLoading: false,
      cur: {},
      show: false,
      selectData: [],
      goodsName: '',
      goodsCategory: '',
      categorys:[
        {value: 1, label: '商品'},
        {value: 2, label: '套餐'}
      ]
    }
  },
  created() {
    this.goodsCategory = 2
    this.getList()
  },
  methods: {
    save() {
      if (this.cur.id) {
        this.updateTeamPackage()
      } else {
        this.addTeamPackage()
      }
    },
    cancel() {
      // this.$refs.form.resetFields()
      this.show = false
      this.modalLoading = false
    },
    // 列表分页
    onCurrentChange(current) {
      this.page = current
      this.getList()
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    // 弹窗分页
    onAddCurrentChange(current) {
      this.addPage = current
      this.serviceSource = []
      this.getGoodsList()
    },
    onAddSizeChange(size) {
      this.addSize = size
      this.getGoodsList()
    },
    //
    showModal(row) {
      this.serviceSource = []
      this.cur = JSON.parse(JSON.stringify(row))
      this.cur.price = row.price - 0
      this.show = true
      this.goodsName = ''
      this.getGoodsList()
    },
    getList() {
      const { page, size } = this
      getTeamPackageApi({ page, size, team_id: this.row.id }).then(res => {
        if (res.code === 0) {
          this.dataSource = res.data
          this.total = res['x-total-count']
          if (this.total && !this.dataSource.length && this.page > 1) {
            this.page = this.page - 1
            this.getList()
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    deleteTeamPackage(id) {
      deleteTeamPackageApi(id).then(res => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    updateTeamPackage() {
      this.modalLoading = true
      const { id, title, price, service_id, image, intro, team_id } = this.cur
      updateTeamPackageApi({
        id,
        team_id,
        title,
        price,
        service_id,
        image,
        intro
      }).then(res => {
        this.modalLoading = false
        if (res.code === 0) {
          this.$Message.success('保存成功')
          this.cancel()
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    addTeamPackage() {
      this.modalLoading = true
      // const { title, price, service_id, image, intro } = this.cur
      addTeamPackageApi(this.selectData).then(res => {
        this.modalLoading = false
        if (res.code === 0) {
          this.$Message.success('保存成功')
          this.cancel()
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 获取商品列表
    getGoodsList() {
      this.serviceSource = []
      fetchGoodsList({
        page: this.addPage,
        size: this.addSize,
        flag: this.goodsCategory,
        goods_name: this.goodsName
      }).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            this.serviceSource.push({
              team_id: this.row.id,
              intro: '',
              id: '',
              service_id: item.id,
              price: item.goods_price,
              image: item.goods_image,
              title: item.goods_name
            })
          })
          this.addTotal = res['x-total-count']
          if (this.addTotal && !this.serviceSource.length && this.addPage > 1) {
            this.addPage = this.addPage - 1
            this.getGoodsList()
          }
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 获取选中数据
    handleSelectionChange(val) {
      this.selectData = val
      console.log(val)
    },
    // 筛选
    handleSearch() {
      this.getGoodsList()
      this.addPage = 1
    }
  }
}
</script>
<style lang="less">
.page-package {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
